(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cart__quantity-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = this.dataset.key;
        const input = document.querySelector(`.cart__quantity-input[data-key="${key}"]`);
        let qty = parseInt(input.value);
        if (this.dataset.action === 'increment') qty++;
        if (this.dataset.action === 'decrement') qty = Math.max(0, qty - 1);
        input.value = qty;
        updateCart(key, qty);
      });
    });

    document.querySelectorAll('.cart__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCart(this.dataset.key, 0);
      });
    });

    function updateCart(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function () {
        window.location.reload();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
